export const CLEAR_COMMON_DATA = 'CLEAR_COMMON_DATA';

//──── Back url ──────────────────────────────────────────────────────────────────────────
export const SET_BACK_URL = 'SET_BACK_URL';
export const RESET_BACK_URL = 'RESET_BACK_URL';

//──── Common filters ────────────────────────────────────────────────────────────────────
export const CLEAR_COMMON_FILTERS = 'CLEAR_COMMON_FILTERS';
export const UPDATE_COMMON_FILTERS = 'UPDATE_COMMON_FILTERS';

//──── Campuses ──────────────────────────────────────────────────────────────────────────
export const ERROR_LOAD_CAMPUSES_LIST = 'ERROR_LOAD_CAMPUSES_LIST';
export const SET_CAMPUSES_LIST = 'SET_CAMPUSES_LIST';

//──── Practitioners ───────────────────────────────────────────────────────────────────────
export const ERROR_LOAD_PRACTITIONERS_LIST = 'ERROR_LOAD_PRACTITIONERS_LIST';
export const SET_PRACTITIONERS_LIST = 'SET_PRACTITIONERS_LIST';
